import { sitePhrasing } from "../../../Language/languageHandler"
import TextInputField from "../../FormFields/TextInputField/TextInputField"
import { ContactInfoFields } from "./ContactInfoFields"
import { referenceNumberSubLabel } from "./PurchaseConstants"

export const GeneralPurchaseFields = (props: {
    errors: any,
    touched: any,
    values: any,
    setFieldValue: any
}) => {

    const {
        values,
        errors,
        touched,
        setFieldValue
    } = props

    return (
        <>
            <ContactInfoFields
                values={values}
                touched={touched}
                errors={errors}
                setFieldValue={setFieldValue}
            />

            <TextInputField
                mask={sitePhrasing.referenceMask}
                fieldName={"referenceNumber"}
                fieldLabel={"Reference Number"}
                fieldSubLabel={referenceNumberSubLabel}
                customFieldInstructions={undefined}
                errors={errors}
                touched={touched}
                required={true}
                placeholder={"Reference Number"}
                maskGuide={sitePhrasing.referenceMaskGuide}
            />

            <TextInputField
                fieldName={"businessName"}
                fieldLabel={"Complete Business Name"}
                errors={errors}
                touched={touched}
                required={true}
                placeholder={"Complete Business Name"}
            />
        </>
    )

}